module.exports = __webpack_public_path__ + "static/media/wfac-banner-main.29a0fa96.png";